import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './FilterLocation.css'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'
import { setFilterChangedId } from '../../services/store/GenericReducer'
import { ReactComponent as LocationIcon } from '../../assets/images/svg/location.svg'


export default function FilterLocation(props) {

    const store = useSelector(state => state.reducer)
    const [showDropDown, setShowDropDown] = useState(false)
    const [cityDropDown, setCityDropDown] = useState([])
    const [filterValue, setFilterValue] = useState(false)
    const [filterDisplay, setFilterDisplay] = useState(props.apiFilter)
    const [autocompleteKey, setAutocompleteKey] = useState(0)
    const dispatch = useDispatch();

    useEffect(() => {
        if (filterValue && props.apiFilter) {
            setFilterDisplay(filterValue)
        }

        // Always call updateFilter when filterValue changes (including when clearing to false)
        if (props.apiFilter?.filterTypeID !== undefined) {
            props.updateFilter(props.apiFilter.filterTypeID, filterValue)
        }

        // Update filterChangedId after updateFilter
        if(!filterValue && store.filterChangedId.includes(props.apiFilter.filterTypeID)){
            let index = store.filterChangedId.indexOf(props.apiFilter.filterTypeID);
            if (index > -1) {
                let newArray = [...store.filterChangedId];
                newArray.splice(index, 1);
                dispatch(setFilterChangedId(newArray))
            }
        }
    }, [filterValue])

    // Build city dropdown for autocomplete
    const setDropdown = () => {
        let innerDropDown = []
        props.cities && props.cities.length > 0 && props.cities?.map(city => {
            let obj = {}
            obj.id = city.cityID
            obj.label = city.cityTitle
            obj.areaID = city.areaID
            obj.areaName = city.areaName
            innerDropDown.push(obj)
        })
        setCityDropDown(innerDropDown)
    }

    const handleFilterClick = (e) => {
        setShowDropDown(!(e.target.id != "city-search" && showDropDown))
    }

    useEffect(() => {
        setDropdown()
    }, [props.cities])

    // Set filter value from store.filterChoices (including URL filters)
    // Looks up full data if filter came from URL (has _fromUrl flag)
    useEffect(() => {
        const storeChoice = store.filterChoices?.[props.apiFilter.filterTypeID]?.choice
        if (!storeChoice) return

        // Check if we need to do URL lookup (either no filterValue yet, or current value still has _fromUrl flag)
        const needsLookup = !filterValue || filterValue._fromUrl

        if (needsLookup && storeChoice._fromUrl) {
            // Look up full data from available options
            if (storeChoice.cityID && props.cities?.length > 0) {
                const cityData = props.cities.find(c => c.cityID === storeChoice.cityID)
                if (cityData) {
                    setFilterValue(cityData)
                    setFilterDisplay(cityData)
                    return
                }
            } else if (storeChoice.areaID && props.areas?.length > 0) {
                const areaData = props.areas.find(a => a.areaID === storeChoice.areaID)
                if (areaData) {
                    setFilterValue(areaData)
                    setFilterDisplay(areaData)
                    return
                }
            }
        }

        // Set value if not set yet (non-URL case)
        if (!filterValue) {
            setFilterValue(storeChoice)
            if (storeChoice.cityTitle || storeChoice.areaTitle) {
                setFilterDisplay(storeChoice)
            }
        }
    }, [store.filterChoices?.[props.apiFilter?.filterTypeID]?.choice, props.cities, props.areas])

    useEffect(() => {
        props.clearFilterLabel > 0 && setFilterDisplay(props.apiFilter)
        props.clearFilterLabel > 0 && setFilterValue(false)
        props.clearFilterLabel > 0 && setAutocompleteKey(prev => prev + 1) // Reset autocomplete
    }, [props.clearFilterLabel])

    // Handle area selection from dropdown
    const handleAreaSelect = (area) => {
        setFilterValue(area) // area object has { areaID, areaTitle }
        setAutocompleteKey(prev => prev + 1) // Reset autocomplete when area is selected
    }

    // Handle city selection from autocomplete
    const handleCitySelect = (_, value) => {
        if (value && value.id) {
            const cityData = props.cities.find(x => x.cityID === value.id)
            if (cityData) {
                setFilterValue(cityData) // cityData has { cityID, cityTitle, areaID, areaName }
            }
        }
    }

    // Clear filter
    const handleClear = () => {
        setFilterDisplay(props.apiFilter)
        setFilterValue(false)
        setAutocompleteKey(prev => prev + 1) // Reset autocomplete
    }

    // Get display text for the input
    const getDisplayText = () => {
        if (filterValue) {
            if (filterValue.cityTitle) {
                return filterValue.cityTitle // City selected
            } else if (filterValue.areaTitle) {
                return filterValue.areaTitle // Area selected
            }
        }
        return filterDisplay.title || filterDisplay.label || 'איפה תרצו להתנדב?'
    }

  return (
    <div onClick={(e) => {handleFilterClick(e)}} aria-expanded={showDropDown} className={`field-wrapper filter_location dropdown cities-dropdown ${showDropDown ? 'show' : ''}`}>
        <label htmlFor="location-search" className="sr-only">איפה תרצו להתנדב?</label>
        <div className="input-with-icon">
            <LocationIcon />
            <input
                type="text"
                id="location-search"
                className={filterValue ? "text-blue" : ""}
                placeholder={getDisplayText()}
                readOnly
            />
            <span className="dropdown-arrow"></span>
        </div>
        <div className="dropdown-content">
            {/* City Autocomplete Search */}
            <div className="search-input-wrapper">
                <Autocomplete
                    key={autocompleteKey}
                    freeSolo
                    disableClearable
                    sx={{
                        display: 'inline-block',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          padding: '0px',
                            borderRadius: '0px',
                        },
                        '& label': {
                            display: 'none'
                        },
                        '& fieldset': {
                            display: 'none'
                        },
                        '& input': {
                            height: '21px !important',
                            padding: '7px 12px !important',
                            font: "16px 'AlmoniDL',Arial,sans-serif"
                        },
                        '& ul': {
                            font: "14px 'AlmoniDL',Arial,sans-serif !important"
                        },
                      }}
                    id="city-search"
                    PaperComponent={({ children }) => (
                        <Paper style={{font: "14px 'AlmoniDL',Arial,sans-serif", fontWeight: '500'}}>{children}</Paper>
                    )}
                    className="city-search"
                    onChange={handleCitySelect}
                    options={cityDropDown.length === 0 ? [{label:"Loading...", id:0}] : cityDropDown}
                    renderInput={(params) => <TextField {...params} placeholder="הקלידו שם ישוב" />}
                />
            </div>

            {/* Areas Dropdown List */}
            <div className="location-list-container list-container">
                <ul className="area-list">
                    <li className="clear-selection" onClick={handleClear}> X נקה בחירה</li>
                    {
                        props.areas?.map((area, index) => {
                            const isSelected = filterValue?.areaID === area.areaID;
                            return (
                                <li
                                    key={index}
                                    onClick={() => handleAreaSelect(area)}
                                    className={`area-item ${isSelected ? 'selected' : ''}`}
                                    data-param-name="filterFieldDisplay"
                                >
                                    <a>{area.areaTitle}</a>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    </div>

  )
}
